import {useCallback, useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import CloudinaryVideo from "../../components/CloudinaryVideo/CloudinaryVideo";
import GridGallery from "../../components/GridGallery/GridGallery";
import {loadDataWithCache} from "../../utils";
import {ProjectsContext} from "../../App";
import './style.scss';

const Project = () => {
   
    const {imagesCache, setImagesCache} = useContext(ProjectsContext);
    const {projectName} = useParams();
    const [gallery, setGallery] = useState([]);
    const [video, setVideo] = useState(null);
    

    const getData = useCallback(async () => {
        setGallery([]);
        setVideo(null);

        const data = await loadDataWithCache(projectName, imagesCache, setImagesCache);
        const video = await loadDataWithCache(projectName, imagesCache, setImagesCache, 'video');

        setGallery(data || []);
        setVideo(video?.[0] || null); // Take the first video if available

    }, [imagesCache, projectName, setImagesCache]);

    useEffect(() => {
        getData();
    },[getData])

    return (
        <div className='project'>
            {video?.context?.custom?.caption && 
                <div className='video-section'>
                    {video && <CloudinaryVideo video={video} />}
                    <div className='text'>
                        <div className='title'>
                            <p className='title_text'>{video.context.custom.caption}</p>
                            <p className='subName' dangerouslySetInnerHTML={{__html: video.context.custom?.subName}} />
                        </div>
                        <p dangerouslySetInnerHTML={{__html: video?.context?.custom?.text}} />
                    </div>
                </div>
            }
            {gallery.length > 0 && <>
                <h2>Gallery</h2>
                <GridGallery images={gallery} lightbox />
            </>}
        </div>
    );
};
export default Project;
